'use strict';

var React = require('react');
require('prop-types');
var Grid = require('../../../DesignSystem/Layout/Grid/Grid.js');
var Typography = require('../../../DesignSystem/DataDisplay/Typography/Typography.js');
var CurrencyDisplay = require('../../CurrencyDisplay.js');
var LineItemImageAndText = require('../LineItems/LineItemImageAndText.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var LineItemRowMobile = function LineItemRowMobile(props) {
  var lineItem = props.lineItem,
      settings = props.settings,
      hasLineItemImages = props.hasLineItemImages;
  var name = lineItem.name,
      quantity = lineItem.quantity,
      unit_price = lineItem.unit_price,
      description = lineItem.description,
      image_url = lineItem.image_url;
  var show_quantity_and_unit_price = settings.show_quantity_and_unit_price,
      show_amount = settings.show_amount;
  var amount = quantity * unit_price;
  var quantityItemSize = show_amount ? 6 : 9;
  var amountItemSize = show_quantity_and_unit_price ? 3 : 12;
  return React__default["default"].createElement(Grid, {
    container: true,
    item: true,
    spacing: 8
  }, React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, React__default["default"].createElement(LineItemImageAndText, {
    hasLineItemImages: hasLineItemImages,
    imageUrl: image_url,
    name: name,
    description: description
  })), React__default["default"].createElement(Grid, {
    container: true,
    item: true
  }, show_quantity_and_unit_price && React__default["default"].createElement(React.Fragment, null, React__default["default"].createElement(Grid, {
    item: true,
    xs: quantityItemSize
  }, React__default["default"].createElement(Typography, {
    variant: "subtitle2",
    align: "right"
  }, "Quantity")), React__default["default"].createElement(Grid, {
    item: true,
    xs: 3
  }, React__default["default"].createElement(Typography, {
    variant: "subtitle2",
    align: "right"
  }, "Unit price"))), show_amount && React__default["default"].createElement(Grid, {
    item: true,
    xs: amountItemSize
  }, React__default["default"].createElement(Typography, {
    variant: "subtitle2",
    align: "right"
  }, "Amount")), show_quantity_and_unit_price && React__default["default"].createElement(React.Fragment, null, React__default["default"].createElement(Grid, {
    item: true,
    xs: quantityItemSize
  }, React__default["default"].createElement(Typography, {
    align: "right"
  }, quantity)), React__default["default"].createElement(Grid, {
    item: true,
    xs: 3
  }, React__default["default"].createElement(Typography, {
    align: "right"
  }, React__default["default"].createElement(CurrencyDisplay, {
    amountInCents: unit_price
  })))), show_amount && React__default["default"].createElement(Grid, {
    item: true,
    xs: amountItemSize
  }, React__default["default"].createElement(Typography, {
    align: "right"
  }, React__default["default"].createElement(CurrencyDisplay, {
    amountInCents: amount
  })))));
};

module.exports = LineItemRowMobile;
